import React, { useState } from "react";
import { RiArrowRightLine } from '@remixicon/react'
import Header from "./../components/Header";

const ExchangePage = () => {

  const [amount, setAmount] = useState("")
  const [selectedCurrency, setSelectedCurrency] = useState("vnd")

  const calculateCoins = () => {
    const numAmount = Number.parseFloat(amount) || 0

    if (selectedCurrency === "vnd") {
      return numAmount / 1000 // 1000 VND = 1 coin
    } else if (selectedCurrency === "usd") {
      return numAmount * 25 // 1$ = 25 coin
    }

    return 0
  }

  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section
          className="js-page page challenges abyss-simple-page"
          data-router-view="challenges"
        >
          <div className="max-w-4xl mx-auto min-h-screen mt-20">
            {/* Calculator Card */}
            <div className="bg-[#2d1b42] rounded-lg p-6 text-white mb-8">
              <div className="mb-4">
                <h3 className="text-lg font-semibold">Exchange</h3>
              </div>
              <div>
                {/* Currency Tabs */}
                <div className="w-full grid grid-cols-2 gap-2 mb-6">
                  <button
                    className={`py-2 px-4 rounded-md ${selectedCurrency === "vnd" ? "bg-[#7928ca]" : "bg-[#1a0b2e]"}`}
                    onClick={() => setSelectedCurrency("vnd")}
                  >
                    VND
                  </button>
                  <button
                    className={`py-2 px-4 rounded-md ${selectedCurrency === "usd" ? "bg-[#7928ca]" : "bg-[#1a0b2e]"}`}
                    onClick={() => setSelectedCurrency("usd")}
                  >
                    USD
                  </button>
                </div>

                <div className="space-y-4">
                  <div className="flex flex-col space-y-2">
                    <label htmlFor="amount">Amount:</label>
                    <div className="relative">
                      <input
                        id="amount"
                        type="number"
                        placeholder="0"
                        min={0}
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        className="w-full bg-[#1a0b2e] border border-[#7928ca] rounded-md py-8 height-[20px] px-8 focus:outline-none focus:ring-2 focus:ring-[#7928ca]"
                      />
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">
                        {selectedCurrency === "vnd" ? "₫" : "$"}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center justify-center my-4">
                    <RiArrowRightLine className="h-6 w-6 text-[#7928ca]" />
                  </div>

                  <div className="flex flex-col space-y-2">
                    {/* <label>Coins:</label> */}
                    <div className="bg-[#7928ca] p-4 rounded-lg text-center">
                      <span className="text-2xl font-bold">{calculateCoins().toLocaleString()}</span>
                      <span className="ml-2">coins</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>
      </main>
    </>
  );
};

export default ExchangePage;
